// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Qp-z","breadcrumbForward":"Rp-z","breadcrumbBack":"Sp-z","selected":"Tp-z"};